import {
  Settings as SettingsIcon,
  Bell,
  Moon,
  Mail,
  ShieldCheck,
  ChevronRight,
} from "lucide-react";

import ProfilePageLayout from "../../components/profile/ProfilePageLayout";

export default function Settings() {

  return (
    <ProfilePageLayout
      title="Configuración"
      subtitle="Personaliza tu experiencia en Debuts Crop."
      icon={SettingsIcon}
    >

      <section className="profile-template-card">

        <div className="profile-card-title">

          <SettingsIcon size={21} />

          <div>
            <h2>Preferencias</h2>
            <p>
              Configuración general de tu cuenta
            </p>
          </div>

        </div>

        <div className="profile-settings-list">

          <div className="profile-setting-item">

            <div className="profile-setting-icon">
              <Bell size={20} />
            </div>

            <div className="profile-setting-content">

              <strong>
                Notificaciones
              </strong>

              <span>
                Recibe novedades y actualizaciones
              </span>

            </div>

            <label className="profile-switch">

              <input
                type="checkbox"
                defaultChecked
              />

              <span></span>

            </label>

          </div>

          <div className="profile-setting-item">

            <div className="profile-setting-icon">
              <Mail size={20} />
            </div>

            <div className="profile-setting-content">

              <strong>
                Correos promocionales
              </strong>

              <span>
                Ofertas, novedades y promociones
              </span>

            </div>

            <label className="profile-switch">

              <input
                type="checkbox"
                defaultChecked
              />

              <span></span>

            </label>

          </div>

          <div className="profile-setting-item">

            <div className="profile-setting-icon">
              <Moon size={20} />
            </div>

            <div className="profile-setting-content">

              <strong>
                Modo visual
              </strong>

              <span>
                Experiencia visual Debuts Crop
              </span>

            </div>

            <strong className="profile-setting-value">
              NEON
            </strong>

          </div>

          <button
            type="button"
            className="profile-setting-item profile-setting-button"
          >

            <div className="profile-setting-icon">
              <ShieldCheck size={20} />
            </div>

            <div className="profile-setting-content">

              <strong>
                Privacidad y seguridad
              </strong>

              <span>
                Administra las opciones de seguridad
              </span>

            </div>

            <ChevronRight size={19} />

          </button>

        </div>

      </section>

    </ProfilePageLayout>
  );
}